export default "__VITE_ASSET__DG2pjdWO__"